import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core/styles';

const useContactUsStyles = makeStyles({
  grindContainer: {
    marginBottom: 16,
  },
  cardGrid: {
    padding: 16,
  },
  card: {
    marginTop: 0,
    height: '100%',
  },
  fullHeight: {
    height: '100%',
  },
});

const useAccountStyles = makeStyles((theme: Theme) => ({
  card: {
    maxWidth: 440,
    height: '100%',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(4),
    },
  },
  LinkColor: {
    color: '#00588f',
  },
  SizeFix: {
    lineHeight: '1.51em',
    fontSize: '1.15em',
  },
}));

const useStylesUsersPage = makeStyles((theme: Theme) => ({
  table: {
    marginTop: theme.spacing(3),
  },
  searchField: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 0,
    width: 376,
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      width: 'unset',
    },

    //NOSONAR TODO: CDS-590
    '& #search-field-input': {
      padding: '12px 16px',
    },
  },
  button: {
    display: 'flex',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('md')]: {
      paddingLeft: '10px',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      padding: 0,
      paddingTop: '16px',
    },

    '& .MuiButtonBase-root.Mui-focusVisible': {
      boxShadow: '0 0 0 4px rgb(0 125 205 / 30%) !important',
      outline: 'none !important',
    },
  },
}));

const useAddUserStyles = makeStyles((theme: Theme) => ({
  fix: {
    fontSize: '1.15em',
  },
  emphasizedText: {
    fontWeight: 600,
  },
  dangerText: {
    fontWeight: 600,
    color: '#ab0d07',
  },
}));

const useConnectedAccountStyles = makeStyles({
  connAcc: {
    fontSize: '2.3em',
  },
  bodyFix: {
    lineHeight: '1.51em',
    fontSize: '1.15em',
  },
});
const useNotFoundPageStyles = makeStyles({
  error404: {
    margin: 32,
    position: 'relative',
    transform: 'none',
    top: 0,
    left: 0,
  },
});

const usePersonalInfoPageStyles = makeStyles(() => ({
  tabs: {
    maxWidth: 300,
    '& .MuiTab-root.Mui-selected': {
      color: '#00588f !important',
    },
  },
  tab: {
    minWidth: 0,
  },
  heading: {
    fontSize: '2.5em',
  },
}));

const useCommunicationPageStyle = makeStyles(() => ({
  fontColor: {
    color: '#00588f',
  },
  contentSize: {
    fontSize: '1em',
    color: '#424242',
    letterSpacing: '0em',
    lineHeight: '1.5em',
  },
}));

const useHomePageStyles = makeStyles(() => ({
  paragraph: {
    lineHeight: '1.5',
    fontSize: '1.15em',
  },
  internalLink: {
    fontWeight: 700,
    fontSize: 'x-small',
    background: '#deefd0',
    padding: '3px 5px',
    borderRadius: '3px',
  },
}));

export {
  useContactUsStyles,
  useAccountStyles,
  useStylesUsersPage,
  useAddUserStyles,
  useConnectedAccountStyles,
  useNotFoundPageStyles,
  usePersonalInfoPageStyles,
  useHomePageStyles,
  useCommunicationPageStyle,
};
